import styled from 'styled-components'

import { Divider } from '@reveni-io/reveni-ui'

export const Container = styled.div`
  padding-top: ${props => props.theme.spacing.sp16};
  padding-bottom: ${props => props.theme.spacing.sp40};
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
`

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const HeaderTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const HeaderInfoContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
  align-items: center;
`

export const HeaderStatusContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`

export const CustomDivider = styled(Divider)`
  //to avoid the gap between the divider and the container
  position: relative;
  left: -32px;
  width: calc(100% + 64px);
`

export const ShippingDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`

export const ProductsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`
